export const

    SET_CHAT_IS_OPEN = 'SET_CHAT_IS_OPEN',
    SET_CHAT_IS_CLOSED = 'SET_CHAT_IS_CLOSED',
    SET_TOTAL_UNREAD_ENTRIES = 'SET_TOTAL_UNREAD_ENTRIES',
    SET_COMPANY = 'set company info in bubble chat',
    SET_CUSTOMIZATION = 'SET_CUSTOMIZATION';



// WEBPACK FOOTER //
// ./redux/actions/types.js